// @flow
import type { Node } from 'react';
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import DeleteIcon from 'material-ui/svg-icons/content/clear';
import ReadIcon from 'material-ui/svg-icons/action/visibility';
import Notification from '../domain/Notification';

const NotificationWrapper = styled.div`
  display: flex;
`;

const HoverableNotificationWrapper = styled(NotificationWrapper)`
  padding: ${({ theme }) => theme.metrics.margin}px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const UnReadNotificationWrapper = styled(HoverableNotificationWrapper)`
  background-color: ${({ theme: { colors } }) => colors.hexToRGBA(colors.primary, 0.2)};
`;

const NotificationContentWrapper = styled.div`
  flex: 1;
`;

const ActionIconsWrapper = styled.div`
  width: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

type NotificationCallback = (notification: Notification) => any;

type Props = {
  notification: Notification,
  theme: any,

  renderNotification: (notification: Notification) => Node,
  onClick: NotificationCallback,
  onRemove: NotificationCallback,
  onRead: NotificationCallback,
}

function NotificationCard(props: Props) {
  const { notification, theme, onClick, onRead, onRemove, renderNotification } = props;

  const color = notification.isRead() ? theme.colors.lightGray : theme.colors.primary;
  const Wrapper = notification.isRead() ? HoverableNotificationWrapper : UnReadNotificationWrapper;

  return (
    <Wrapper onClick={() => onClick(notification)} style={{ outline: 'lightgray 1px solid' }}>
      <NotificationContentWrapper>
        {renderNotification(notification)}
      </NotificationContentWrapper>
      <ActionIconsWrapper>
        <DeleteIcon
          style={{ width: 16, height: 16 }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(notification);
          }}
        />
        <ReadIcon
          style={{ width: 16, height: 16, color }}
          onClick={(e) => {
            e.stopPropagation();
            onRead(notification);
          }}
        />
      </ActionIconsWrapper>
    </Wrapper>
  );
}

export default withTheme(NotificationCard);



// WEBPACK FOOTER //
// ./src/common/modules/ui/components/NotificationCard.js